/**
 * Contratos zod del endpoint Ubicaciones.
 *
 * Estos schemas son la SPEC del API. Eze (back-end dev) los lee para
 * implementar los endpoints reales — el back debe cumplir el contrato
 * (request acepta, response cumple).
 *
 * Los tipos TS se infieren con `z.infer` — single source of truth.
 */

import { z } from 'zod';
import { TIPOS_ACTOR } from '@/domain/types';

export const TipoActorSchema = z.enum(TIPOS_ACTOR);

export const UbicacionSchema = z.object({
  id: z.string().min(1),
  nombre: z.string().min(1),
  // GS1 GLN son 13 dígitos numéricos en producción, pero permitimos placeholders
  // alfanuméricos (ej. "glnws") para datos de prueba. La validación estricta de
  // formato + check digit corresponde al backend.
  gln: z.string().min(1, 'GLN requerido'),
  tipoActor: TipoActorSchema,
  direccion: z.string().optional(),
  cuit: z.string().optional(),
  tipo: z.string().optional(),
  externa: z.boolean().optional(),
});

export const GetUbicacionesResponse = z.array(UbicacionSchema);

export type Ubicacion = z.infer<typeof UbicacionSchema>;
